<div fxLayout="row" fxFlex="100" id="formRange" fxLayoutGap="10px">
  <div fxLayout="row" fxFlex="50" fxFlex.sm="50">
    <input matInput type="number" class="right" (change)="valueChange('From',$event.target.value)" [(ngModel)]="valueFrom" min="0" placeholder="0,00">
  </div>
  <div fxLayout="row" fxFlex="50" fxFlex.sm="50">
    <input matInput type="number" class="right" (change)="valueChange('To',$event.target.value)" [(ngModel)]="valueTo" min="0" placeholder="0,00">
  </div>
</div>
